export default __webpack_public_path__ + "static/media/click.b05b4dbc.mp3";